module.exports = __webpack_public_path__ + "static/media/20-years-logo.78c748b5.png";